import { render, staticRenderFns } from "./StatusChip.vue?vue&type=template&id=70bea823"
import script from "./StatusChip.vue?vue&type=script&lang=ts"
export * from "./StatusChip.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/codebuild/output/src4020427597/src/jobbliss-app-vue/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('70bea823')) {
      api.createRecord('70bea823', component.options)
    } else {
      api.reload('70bea823', component.options)
    }
    module.hot.accept("./StatusChip.vue?vue&type=template&id=70bea823", function () {
      api.rerender('70bea823', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/icons/StatusChip.vue"
export default component.exports